export default {
	add: 'إضافة نظام دوام',

	table: {
		name: 'نظام الدوام',
		totalHours: 'عدد ساعات في الاسبوع',
		vacations: 'ايام العطل',
	},

	addType: {
		title: 'إضافة نظام دوام',
		name: 'اسم نظام الدوام',
		hoursNumber: 'عدد الساعات في الاسبوع',
		hourly: 'ساعي',
		daily: 'يومي',
		hybrid: 'هجين',
		late: 'تأخير',
		earlyLeave: 'إنصراف مبكر',
		extra: 'إضافي',
		absent: 'غياب',
		allowedTime: 'الوقت المسموح',
		inMinute: 'دقيقة',
		subtract: 'الخصم',
		// static: 'رقم ثابت',
		static: 'كمبلغ',
		// percentage: 'نسبة إلى الراتب',
		percentage: 'كنسبة',
		extraStart: 'يبدأ بعد',
		extraMax: 'سقف الإضافي',
		extraValue: 'القيمة الإضافي',
		minInDay: 'دقيقة/اليوم',
		hourInMonth: 'ساعة/الشهر',
	},
	'hours-on-day': 'عدد ساعات العمل في اليوم',
	'minimum-work-hours': 'الحد الأدنى لعدد الساعات باليوم',
	'work-deadline-hours': 'الحد النهائي لدوام اليوم'
};
